module.exports = __webpack_public_path__ + "img/rg.ac50dad3.svg";